export default "__VITE_ASSET__ClfdU6x9__"